import React, { useState, useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { fetchData, postData, putData, updateData, deleteData, activateData } from '../../../apiService'; // Assuming putData is used for updating
import { Card, CardContent, TableContainer, Paper, Tooltip, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton } from '@mui/material';
import Select from 'react-select';
import DeleteIcon from '@mui/icons-material/Delete';
import ActivateIcon from '@mui/icons-material/CheckCircle';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Modal from '@mui/material/Modal';
import { FaTimes } from 'react-icons/fa';
import CircularProgress from '@mui/material/CircularProgress';
import Button from '@mui/material/Button';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RefreshIcon from '@mui/icons-material/Refresh';
import { Link } from 'react-router-dom';
import BlockIcon from '@mui/icons-material/Block';
import { TextField } from '@mui/material';
import { Discount } from '@mui/icons-material';
import UndoIcon from '@mui/icons-material/Undo';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';

const SaleReturnEdit = () => {
    const { id, tid } = useParams();
    const history = useHistory();
    const [isLoading, setIsLoading] = useState(false);
    const [loading, setLoading] = useState(false);
    const { isAuthenticated, companyId, userId, token, logout } = useAuth();

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
        }
    }, [isAuthenticated, token, logout]);

    const [DateInvoice, setDateInvoice] = useState('');
    const [customerId, setCustomerId] = useState('');
    const [TripId, setTripId] = useState('');
    const [SaleId, setSaleId] = useState('');
    const [qty, setQty] = useState('');
    const [successMessages, setSuccessMessages] = useState("");
    const [errorMessages, setErrorMessages] = useState("");
    const [selectedItem, setSelectedItem] = useState(null);
    const [saleData, setSaleData] = useState([]);
    const [modalOpen, setModalOpen] = useState(false);
    const [itemnameget, setItemName] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [quantities, setQuantities] = useState([]);
    const [searchDate, setSearchDate] = useState('');
    const [ReturnTaxableAmt, setReturnTaxableAmt] = useState('');
    const [filteredSaleData, setFilteredSaleData] = useState([]);
    const [selectedInvoices, setSelectedInvoices] = useState([]);
    const [customerOptions, setCustomerOptions] = useState([]);
    const [getDate, setGetData] = useState([]);
    const [selectedCustomerType, setSelectedCustomerType] = useState("");
    const [RQuantities, setRQuantities] = useState([]);
    const [currentDisplayedDate, setCurrentDisplayedDate] = useState(null);
    const [showSelectedInvoice, setShowSelectedInvoice] = useState(false);
    const [ReturnId, setReturnIdId] = useState(null);
    const [deleteItemId, setDeleteItemId] = useState(null);
    const [remark, setRemark] = useState("");
    // const [Isdelete, setIsdelete] = useState(false);
    const [RouteName, setRouteName] = useState('');
    const [searchQuery, setSearchQuery] = useState(""); // State for search query
    const [formData, setFormData] = useState({
        datas: {
            CustomerId: '',
            CustomerName: '',
            Remark: '',
            RQuantity: '',
        }
    });
    const [getDatesale, setGetDatasale] = useState({
        datas: {
            RQuantity: '',
        }
    });

    useEffect(() => {
        fetchSaleReturnData();
    }, []);

    useEffect(() => {
        fetchtableData();
    }, []);

    // customer name
    const fetchtableData = async () => {
        fetchData('CustomerApi', `/${companyId}`, token)
            .then((response) => {
                if (response.responseCode == '1111') {
                    const options = response.response_data.map(customer => ({
                        value: customer.id,
                        label: customer.name + customer.addressLine1 + customer.customerCode
                    }));
                    setCustomerOptions(options);
                }
            })
            .catch((error) => {
                console.error('Error fetching customer Details:', error);
            });
    };

    const handleCustomerChange = (selectedOption) => {
        setSelectedCustomerType(selectedOption);
        setFormData((prevData) => ({
            ...prevData,
            CustomerId: selectedOption ? selectedOption.value : null,
        }));
    };

    const fetchSaleReturnData = async () => {
        try {
            setLoading(true);
            const response = await fetchData('ReturnApi', `/SaleReturn/${id}`, token);
            if (response.responseCode === '1111') {
                setFormData(response.response_data);
                const array = response.response_data;
                console.log(response);
                setTripId(response.response_data.TripId);
                const selectedcustomerOption = customerOptions.find(option => option.value === response.response_data.CustomerId);
                setSelectedCustomerType(selectedcustomerOption);
                setCustomerId(response.response_data.CustomerId)
                setRouteName(response.response_data.Route)
            }
        } catch (error) {
            console.error('Error fetching sale return data:', error);
        }
        finally {
            setLoading(false);
        }
    };

    const handleChange = event => {
        const { name, value } = event.target;
        setFormData(prevData => ({
            ...prevData,
            [name]: value
        }));
    };

    //invoice date
    const handleCustomerTypeChange = async () => {
        const response = await fetchData('SaleReturnApi', `/${companyId}/${customerId}`, token);
        if (response.responseCode === '1111') {
            const sortedData = response.response_data.sort((a, b) => new Date(b.invoiceDate) - new Date(a.invoiceDate));
            setSaleData(sortedData);
            setFilteredSaleData(sortedData);
            setQuantities(new Array(sortedData.length).fill(''));
            setShowModal(true);
        }
    };

    //scroll
    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            backgroundColor: state.isDisabled ? '#f0f0f0' : provided.backgroundColor,
        }),
        singleValue: (provided, state) => ({
            ...provided,
            color: state.isDisabled ? '#000' : provided.color,
        }),
        placeholder: (provided, state) => ({
            ...provided,
            color: state.isDisabled ? '#000' : provided.color,
        }),
    };
    const handleRefreshClick = () => {
        window.location.reload();
    };

    useEffect(() => {
        fetchtableReturnData();
    }, []);


    const AddtoListdata = (e) => {
        e.preventDefault();
        const updatedItem = { quantity: parseInt(qty) };
        setItemList([...itemList, updatedItem]);
        setNewItem({
            quantity: 1,
        });
        setSelectedItem(null);
        setQty('');
    };
    /////////table data

    const fetchtableReturnData = async () => {
        try {
            const response = await fetchData('ReturnSaleOrderApi', `/SaleReturn/${id}`, token);
            if (response.responseCode === '1111') {
                const dataArray = response.response_data;
                setGetData(response.response_data);
                setGetDatasale(response.response_data);
                setReturnIdId(response.response_data.map(item => item.ID));
                setDateInvoice(dataArray[0].invoiceDate);
                console.log(response);
                setRQuantities(response.response_data.map(item => item.RQuantity));
            }
        } catch (error) {
            console.error('Error fetching sale return data:', error);
        }
    };
    const handleRQuantityChange = (index, value) => {
        const updatedQuantities = [...RQuantities];
        updatedQuantities[index] = value;
        setRQuantities(updatedQuantities);
    };

    // calculation {gst, taxable values...........}
    function calculateTotalAmount(rateAfterDiscount, gstrate, quantities, bagweight) {
        gstrate = gstrate || 0;
        const totalQty = quantities * bagweight;
        const taxableAmount = rateAfterDiscount * totalQty * 100 / (100 + gstrate);
        const cgstAmount = taxableAmount * gstrate / (2 * 100);
        const sgstAmount = taxableAmount * gstrate / (2 * 100);
        const igstAmount = 0;
        const totalAmount = taxableAmount + cgstAmount + sgstAmount + igstAmount;
        return isNaN(totalAmount) ? 0 : totalAmount.toFixed(2);
    }

    function calculateGst(rapeperpeice, gstrate, quantities, bagweight) {
        const cgstAmount = calculateCGST(rapeperpeice, gstrate, quantities, bagweight);
        const sgstAmount = calculateSGST(rapeperpeice, gstrate, quantities, bagweight);
        const igstAmount = 0;
        const gst = cgstAmount + sgstAmount + igstAmount;
        return isNaN(gst) ? 0 : gst.toFixed(2);

    }

    function calculateCGST(rateAfterDiscount, gstrate, quantities, bagweight) {
        gstrate = gstrate || 0;
        const totalQty = quantities * bagweight;
        const taxableAmount = rateAfterDiscount * totalQty * 100 / (100 + gstrate);
        const cgstAmount = taxableAmount * gstrate / (2 * 100);
        const sgstAmount = taxableAmount * gstrate / (2 * 100);
        return cgstAmount;
    }

    function calculateSGST(rateAfterDiscount, gstrate, quantities, bagweight) {
        gstrate = gstrate || 0;
        const totalQty = quantities * bagweight;
        const taxableAmount = rateAfterDiscount * totalQty * 100 / (100 + gstrate);
        const cgstAmount = taxableAmount * gstrate / (2 * 100);
        const sgstAmount = taxableAmount * gstrate / (2 * 100);
        return sgstAmount;
    }

    function taxableAmount(rateAfterDiscount, gstrate, quantities, bagweight) {
        gstrate = gstrate || 0;
        const totalQty = quantities * bagweight;
        const taxableAmount = rateAfterDiscount * totalQty * 100 / (100 + gstrate);
        //  const SRTaxable = taxableAmount.flatMap(item => item.taxableAmount);

        return isNaN(taxableAmount) ? 0 : taxableAmount.toFixed(2);

    }

    const closeModal = () => {
        setShowModal(false);
    };
    const closeModaladd = () => {
        setShowModal(false);
    };

    //invoice date model
    const handleInvoiceButton = () => {
        handleCustomerTypeChange();
        setShowModal(true);
    };
    const handleAddnewItemButton = () => {
        setModalOpen(true);
    };
    const combinedInvoiceData = selectedInvoices.flatMap(invoice => invoice.data);

    // fetch already exist data
    const handleInvoiceClick = async (invoice) => {
        try {
            const isSelected = selectedInvoices.some(inv => inv.id === invoice.id);
            if (isSelected) {
                setSelectedInvoices(prevInvoices => prevInvoices.filter(inv => inv.id !== invoice.id));
                setGetData(prevGetData => prevGetData.filter(item => item.invoiceId !== invoice.id));
                setGetDatasale(prevGetDatasale => prevGetDatasale.filter(item => item.invoiceId !== invoice.id));
                setDateInvoice(null);
                setRQuantities([]);
                setShowSelectedInvoice(false);
            } else {
                const saleReturnApiResponse = await fetchData('SaleReturnApi', `/SaleReturn/${invoice.id}`, token);
                if (saleReturnApiResponse.responseCode === '1111') {
                    const saleReturnData = saleReturnApiResponse.response_data;
                    setGetData(prevGetData => [...prevGetData, ...saleReturnData]);
                    //  setIsdelete(true)
                    setDateInvoice(saleReturnData.length > 0 ? saleReturnData[0].invoiceDate : null); // Update date for new invoice data
                    setRQuantities(prevRQuantities => [...prevRQuantities, ...saleReturnData.map(item => item.RQuantity)]);
                }

                const returnSaleOrderApiResponse = await fetchData('ReturnSaleOrderApi', `/SaleReturn/${invoice.id}`, token);
                if (returnSaleOrderApiResponse.responseCode === '1111') {
                    const returnSaleOrderData = returnSaleOrderApiResponse.response_data;
                    setTripId(invoice.tripID)
                    setGetDatasale(prevGetDatasale => [...prevGetDatasale, ...returnSaleOrderData]);
                }

                setCurrentDisplayedDate(invoice.invoiceDate);
                setSelectedInvoices(prevInvoices => [...prevInvoices, invoice]);
                setShowSelectedInvoice(true);
            }
        } catch (error) {
            console.error('Error fetching invoice data:', error);
        }
    };

    const [newItem, setNewItem] = useState({
        Id: '',
        quantity: 1,
    });

    // search invoice date
    const handleSearch = () => {
        const filteredData = saleData.filter(item => {
            const invoiceDate = new Date(item.invoiceDate).toLocaleDateString('en-GB');
            return invoiceDate.includes(searchDate);
        });
        setFilteredSaleData(filteredData);
    };

    // table values search
    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
    };
    const filteredDatatable = getDate.filter(item =>
        item.ItemName.toLowerCase().includes(searchQuery.toLowerCase()) ||
        item.invoiceDate && new Date(item.invoiceDate).toLocaleDateString('en-GB').includes(searchQuery.toLowerCase())

    );


    const [itemList, setItemList] = useState([]);
    const [itemToDeleteIndex, setItemToDeleteIndex] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [itemName, setItemNames] = useState('');


    const handleDelete = async () => {
        if (itemToDeleteIndex !== null) {
            const updatedItemList = filteredDatatable.filter((_, i) => i !== itemToDeleteIndex);
            setGetData(updatedItemList);

            // Also filter out the corresponding RQuantities
            const updatedQuantities = RQuantities.filter((_, i) => i !== itemToDeleteIndex);
            setRQuantities(updatedQuantities);

            closeConfirmDialog();
            // const updatedItemList = filteredDatatable.filter((_, i) => i !== itemToDeleteIndex);
            // setGetData(updatedItemList);
            // closeConfirmDialog();

        }
        else if (deleteItemId !== null) {
            deleteData('SaleReturnApi', `${deleteItemId}`, token)
                .then((response) => {
                    fetchtableData();
                    setDeleteItemId(null);
                    setConfirmDialogOpen(false);
                    window.location.reload();

                })
                .catch((error) => {
                    console.error('Error deleting record:', error);
                });
        }
    };


    const closeConfirmDialog = () => {
        setConfirmDialogOpen(false);
        setItemToDeleteIndex(null);
        setDeleteItemId(null);
        setItemNames('');
    };
    const openConfirmDialog = (index) => {
        setItemToDeleteIndex(index);
        setDeleteItemId(null);
        setItemNames('');
        setConfirmDialogOpen(true);
    };

    const ConfirmDialog = (deleteItemId, itemname) => {
        setItemToDeleteIndex(null);
        setDeleteItemId(deleteItemId);
        setItemName(itemname)
        setConfirmDialogOpen(true);
    };
    // const ConfirmDialog = (deleteItemId, itemname) => {
    //     setDeleteItemId(deleteItemId);
    //     setItemName(itemname)
    //     setConfirmDialogOpen(true);
    // };



    // save
    const submitData = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        const saleReturnData = {
            Id: id,
            TripId: parseInt(TripId),
            CustomerId: customerId,
            ModifiedBy: userId,
            ModifiedDate: new Date(),
            SaleID: SaleId || null,
            ItemName: getDate.find(item => item.ItemId === SaleId)?.ItemName || 'Unknown',
            Remark: formData.Remark

        };

        const saleReturnDetails = [];

        RQuantities.forEach((quantity, index) => {
            if (quantity && quantity > 0) {
                const item = getDate[index];
                saleReturnDetails.push({
                    CustomerId: customerId,
                    CompanyId: companyId,
                    RQuantity: parseInt(quantity),
                    UpdatedBy: userId,
                    UpdatedDate: new Date(),
                    SaleID: item.SaleID,
                    TripId: item.TripID,
                    Item: item.ItemName,
                    ItemId: item.ItemId,
                    Rate: item.Rate,
                    SRate: item.TotalAmount,
                    SQuantity: item.Quantity,
                    ItemId: item.ItemId,
                    GSTRate: item.GSTRate,
                    ItemName: item.ItemName,
                    invoiceDate: item.invoiceDate,
                    DiscountAmount: item.DiscountAmount,
                    DiscountPerkg: item.DiscountPerPiece,
                    Bagweight: item.ItemBagWeight,
                    RateperKg: item.ItemRatePerKg,
                    RateAfterDiscount: item.RateAfterDiscount

                });
            }
        });

        const CreateData = {
            SaleReturn: saleReturnData,
            SaleReturnDetails: saleReturnDetails,
        };
        try {
            const response = await updateData('SaleReturnApi', `${id}`, CreateData, token);
            console.log('Sale Return success:', response);
            setQuantities(Array(getDate.length).fill(""));
            setSuccessMessages("Sale Return successfully!");
            setErrorMessages("");
            history.push('/SaleReturnIndex');
            setTimeout(() => {
                setSuccessMessages("");
            }, 3000);
        } catch (error) {
            console.error('Sale Return error:', error);
            setIsLoading(false);
        }

    };
    //const dataItem = getData[index]; 
    const invoiceDates = getDate.flatMap(item => item.invoiceDate);

    const totalValues = filteredDatatable.reduce((acc, item, idx) => {
        const rQuantity = RQuantities[idx] || 0;
        const itemTotal = {
            itemRatePerKg: acc.itemRatePerKg + item.ItemRatePerKg,
            discountPerPiece: acc.discountPerPiece + item.DiscountPerPiece,
            rateAfterDiscount: acc.rateAfterDiscount + item.RateAfterDiscount,
            quantity: acc.quantity + item.Quantity,
            gstRate: acc.gstRate + item.GSTRate,
            returnRateAfterDiscount: acc.returnRateAfterDiscount + item.RateAfterDiscount,
            rQuantities: acc.rQuantities + rQuantity,
            totalQty: acc.totalQty + (item.ItemBagWeight * rQuantity),
            taxableAmt: acc.taxableAmt + taxableAmount(item.RateAfterDiscount, item.GSTRate, rQuantity, item.ItemBagWeight),
            gst: acc.gst + calculateGst(item.RateAfterDiscount, item.GSTRate, rQuantity, item.ItemBagWeight),
            netAmt: acc.netAmt + calculateTotalAmount(item.RateAfterDiscount, item.GSTRate, rQuantity, item.ItemBagWeight)
        };
        return itemTotal;
    }, {
        itemRatePerKg: 0,
        discountPerPiece: 0,
        rateAfterDiscount: 0,
        quantity: 0,
        gstRate: 0,
        returnRateAfterDiscount: 0,
        rQuantities: 0,
        totalQty: 0,
        taxableAmt: 0,
        gst: 0,
        netAmt: 0
    });


    return (
        <div className="container w-full max-w-sm container mt-2 mx-auto" style={{ overflow: 'auto', maxWidth: '98%' }}>
            <style>
                {`
        .container::-webkit-scrollbar {
          width: 0.1em;
        }
        .container::-webkit-scrollbar-track {
          background: rgba(255,255,255,0);
        }
        .container::-webkit-scrollbar-thumb {
          background-color: rgba(255,255,255,0);
          border-radius: 4px;
        }
      `}
            </style>
            <div>
                <div className="w-full sm:w-full mb-4 rounded-lg shadow-lg" style={{ backgroundColor: 'rgba(255, 255, 255, 0)' }}>
                    {loading && (
                        <div style={{
                            position: 'fixed',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                            backgroundColor: 'rgba(0, 0, 0, 0.5)',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            zIndex: 9999
                        }}>
                            <div>
                                <CircularProgress style={{ color: 'white' }} />
                                <span style={{ color: 'white', marginTop: '10px', display: 'block' }}>Loading...</span>
                            </div>
                        </div>
                    )}
                    <CardContent>
                        <div>
                            <h6 className="uppercase tracking-wide text-black flex-grow linkcolor"
                                style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'brown' }}>Sale Return Edit</h6>
                        </div>
                        <div style={{ marginTop: '-35px', marginLeft: '45%' }}>
                            <h6 className="uppercase tracking-wide text-brown flex-grow linkcolor"
                                style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'brown' }}>Route : {RouteName}</h6>
                        </div>
                        <div className="flex mb-2" style={{ justifyContent: "flex-end" }}>
                            <Tooltip title="Exit">
                                <Link to="/SaleReturnIndex" style={{ color: 'red', textDecoration: 'none' }}>
                                    <Button variant="contained" color="error" style={{ marginLeft: '10px' }}>
                                        Back
                                    </Button>
                                </Link>
                            </Tooltip>

                            &nbsp;&nbsp;
                            <Button onClick={handleInvoiceButton} style={{ backgroundColor: 'darkmagenta', color: 'white' }} >
                                <CalendarMonthIcon style={{ fontWeight: 'bolder' }} />  Sale Date
                            </Button>
                            &nbsp;&nbsp;
                            <Button onClick={submitData} style={{ backgroundColor: 'darkgreen', color: 'white' }} disabled={isLoading}>
                                {isLoading ? <CircularProgress size={24} color="inherit" /> : "Update"}
                            </Button>

                        </div>

                        <div className="w-full mr-2 mb-2 flex items-center">
                            <label className="block uppercase tracking-wide  text-xs font-bold mb-2" htmlFor="name">
                                Customer
                            </label> &nbsp;&nbsp;
                            <div className="flex-grow" style={{ maxWidth: '40%', minWidth: '300px' }}>
                                {/* <Select
                                    value={selectedCustomerType || (formData.CustomerName + ' ' +formData.AddressLine1 + ' ' + formData.CustomerCode ?{value: formData.CustomerName + ' ' +formData.AddressLine1 + ' ' + formData.CustomerCode, label: formData.CustomerName + ' ' +formData.AddressLine1 + ' ' + formData.CustomerCode } : '')}
                                  
                                    onChange={handleCustomerChange}
                                    options={customerOptions}
                                    placeholder="Customer"
                                    styles={customStyles}
                                    isSearchable
                                    isDisabled
                                /> */}
                                <Select
                                    value={
                                        selectedCustomerType ||
                                        (formData.CustomerName && formData.AddressLine1 && formData.CustomerCode
                                            ? {
                                                value: `${formData.CustomerName} ${formData.AddressLine1} ${formData.CustomerCode}`,
                                                label: `${formData.CustomerName} ${formData.AddressLine1} ${formData.CustomerCode}`
                                            }
                                            : '')
                                    }
                                    onChange={handleCustomerChange}
                                    options={customerOptions}
                                    placeholder="Customer"
                                    styles={customStyles}
                                    isSearchable
                                    isDisabled
                                />
                            </div>

                            <Tooltip title="Refresh">
                                <Button onClick={handleRefreshClick} startIcon={<RefreshIcon />} style={{ marginLeft: '8px' }}>
                                </Button>
                            </Tooltip>


                            <label className="block uppercase tracking-wide  text-xs font-bold mb-2" htmlFor="name">
                                Remark</label>
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            <div className="mr-2" style={{ width: '300px' }}>

                                {/* Dropdown for selecting a predefined remark */}
                                <select
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.Remark}
                                    onChange={handleChange}
                                >
                                    <option value="" disabled>Select Remark</option>
                                    <option value="Order Cancellation">Order Cancellation</option>
                                    <option value="Additional Order Return">Additional Order Return</option>
                                    <option value="Extra Loading Return">Extra Loading Return</option>
                                    <option value="Old Sale Return">Old Sale Return</option>
                                </select>

                                {/* Input field for entering a custom remark */}


                            </div>

                        </div>



                        <div className='w-full mb-5 flex' style={{ maxHeight: '540px', overflowY: 'auto', marginTop: '-0.20%' }}>
                            <TableContainer component={Paper}>
                                {/* <div style={{ maxHeight: '400px', overflowY: 'auto' }}> */}
                                <div>
                                    <table className="table">
                                        <thead>
                                            <tr>
                                                <th style={{ width: '50px' }}>Sl.No</th>
                                                <Tooltip title="Sale Date"><th style={{ width: '50px' }}>S.Date</th></Tooltip>
                                                <Tooltip title="Sale Bill No"><th>Bill No</th></Tooltip>
                                                <Tooltip title="Item Name"><th>Name</th></Tooltip>
                                                <Tooltip title="Rate"><th>Rate<p style={{ fontSize: '8px', marginBlock: '-7px', fontFamily: ' Times New Roman", Times, serif' }}>(per piece)</p></th></Tooltip>
                                                <th>Discount</th>
                                                <Tooltip title="Sale Rate"><th>Rate <p style={{ fontSize: '10px', marginBlock: '-7px', fontFamily: ' Times New Roman", Times, serif' }}>(after discount)</p></th></Tooltip>
                                                <Tooltip title="Sale Quantity"><th>S.Qty <p style={{ fontSize: '8px', marginBlock: '-7px', fontFamily: ' Times New Roman", Times, serif' }}>(No.of pieces) </p></th></Tooltip>
                                                <th>GST %</th>
                                                <Tooltip title="Return Rate"><th>R.Rate</th></Tooltip>
                                                <Tooltip title="Return Quantity"><th>R.Qty <p style={{ fontSize: '8px', marginBlock: ' -7px', fontFamily: ' Times New Roman", Times, serif' }}>(No.of pieces)</p></th></Tooltip>
                                                <Tooltip title="Total Quantity"><th style={{ width: '80px' }}>Total Qty</th></Tooltip>
                                                <Tooltip title="Taxable Amount"><th style={{ width: '80px' }}>Taxable Amt</th></Tooltip>
                                                <th>GST</th>
                                                <Tooltip title="Net Amount"><th>Net Amt</th></Tooltip>
                                                <th>Delete</th>

                                            </tr>
                                        </thead>

                                        <tbody>

                                            {filteredDatatable.map((item, index) => (
                                                <tr key={index}>
                                                    <td className="border-r">{index + 1}</td>
                                                    <td className=" border-r">  {item.invoiceDate ? new Date(item.invoiceDate).toLocaleDateString('en-GB') : ''}</td>
                                                    <td className=" border-r">{item.Prefix}{item.InvoiceNo}/{item.FinYear}</td>

                                                    <td className="border-r">{item.ItemName}</td>
                                                    <td className="px-4 py-2 border-r" style={{ textAlign: 'right' }}>{(item.ItemRatePerKg).toFixed(2)}</td>
                                                    <td className="border-r" style={{ textAlign: 'right' }}>
                                                        {item.DiscountPerPiece}
                                                    </td>
                                                    <td className="px-4 py-2 border-r" style={{ textAlign: 'right' }}>{(item.RateAfterDiscount).toFixed(2)}</td>
                                                    <td className="border-r" style={{ textAlign: 'right' }}>{item.Quantity}</td>
                                                    <td className="px-4 py-2 border-r" style={{ textAlign: 'right' }}>{(item.GSTRate)}</td>
                                                    <td className="border-r" style={{ textAlign: 'right', width: '80px' }}>{(item.RateAfterDiscount).toFixed(2)}</td>
                                                    <td className="border-r" style={{ padding: '1px', fontSize: '14px', width: '80px', textAlign: 'Right' }}>
                                                        <input
                                                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                                            name="RQuantity"
                                                            value={RQuantities[index] || ''}
                                                            style={{ backgroundColor: RQuantities[index] > 0 ? '#FFD6D1' : 'inherit', width: '80px' }}
                                                            onChange={(e) => {
                                                                const input = e.target.value.replace(/\D/g, '');
                                                                if (input.length <= 4) {
                                                                    const newQuantity = parseInt(input, 10);
                                                                    //if (newQuantity <= item.Quantity || input === '') {
                                                                    handleRQuantityChange(index, input);
                                                                    // } else {
                                                                    //     if (input !== '') {
                                                                    //         alert(`⚠️ Return Quantity should be less than Sale Quantity!`);
                                                                    //     }
                                                                    // }
                                                                }
                                                            }}

                                                            type="text"
                                                            min="0"
                                                        />
                                                    </td>
                                                    <td className="border-r" style={{ textAlign: 'right' }}>{isNaN(item.ItemBagWeight * RQuantities[index]) ? '0.00' : (item.ItemBagWeight * RQuantities[index])}</td>

                                                    <td className="border-r" style={{ textAlign: 'right' }}>{isNaN(taxableAmount(item.RateAfterDiscount, item.GSTRate, RQuantities[index], item.ItemBagWeight)) ? '0.00' : taxableAmount(item.RateAfterDiscount, item.GSTRate, RQuantities[index], item.ItemBagWeight)}</td>
                                                    <td className="border-r" style={{ textAlign: 'right', width: '80px' }}>{isNaN(calculateGst(item.RateAfterDiscount, item.GSTRate, RQuantities[index], item.ItemBagWeight)) ? '0.00' : (calculateGst(item.RateAfterDiscount, item.GSTRate, RQuantities[index], item.ItemBagWeight))}</td>
                                                    <td className="px-4 py-2 border-r" style={{ textAlign: 'right' }}>{isNaN(calculateTotalAmount(item.RateAfterDiscount, item.GSTRate, RQuantities[index], item.ItemBagWeight)) ? '0.00' : calculateTotalAmount(item.RateAfterDiscount, item.GSTRate, RQuantities[index], item.ItemBagWeight)}</td>
                                                    <td className="border-r" style={{ textAlign: 'right' }}>
                                                        {item.Isdelete ? (
                                                            <Tooltip title="Delete">
                                                                <DeleteIcon
                                                                    style={{ color: 'brown', cursor: 'pointer', marginRight: '8px' }}
                                                                    onClick={() => openConfirmDialog(index)}
                                                                />
                                                            </Tooltip>
                                                        ) :
                                                            <Tooltip>
                                                                <IconButton onClick={() => (item.IsActive ? ConfirmDialog(item.ID, item.ItemName) : "")}>
                                                                    {item.IsActive ? <DeleteIcon style={{ color: 'brown' }} /> : ""}
                                                                </IconButton>
                                                            </Tooltip>
                                                        }

                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                        <tfoot>
                                            <tr >
                                                <td className="border-r text-left text-sm " colSpan="4" style={{ backgroundColor: 'rgb(190 242 225)' }}>Total</td>
                                                <td className="px-4 py-2 border-r text-right text-sm" style={{ backgroundColor: 'rgb(190 242 225)' }}>{filteredDatatable.reduce((acc, item) => acc + item.ItemRatePerKg, 0).toFixed(2)}</td>
                                                <td className="border-r text-right text-sm" style={{ backgroundColor: 'rgb(190 242 225)' }}>{filteredDatatable.reduce((acc, item) => acc + item.DiscountPerPiece, 0).toFixed(2)}</td>
                                                <td className="px-4 py-2 border-r text-right text-sm" style={{ backgroundColor: 'rgb(190 242 225)' }}>{filteredDatatable.reduce((acc, item) => acc + item.RateAfterDiscount, 0).toFixed(2)}</td>
                                                <td className="border-r text-right text-sm" style={{ backgroundColor: 'rgb(190 242 225)' }}>{filteredDatatable.reduce((acc, item) => acc + item.Quantity, 0)}</td>
                                                <td className="px-4 py-2 border-r text-right text-sm" style={{ backgroundColor: 'rgb(190 242 225)' }}>{filteredDatatable.reduce((acc, item) => acc + item.GSTRate, 0)}</td>
                                                <td className="border-r text-right text-sm" style={{ backgroundColor: 'rgb(190 242 225)' }}>{filteredDatatable.reduce((acc, item) => acc + item.RateAfterDiscount, 0).toFixed(2)}</td>
                                                <td className="border-r text-right text-sm" style={{ backgroundColor: 'rgb(190 242 225)' }}>
                                                    {filteredDatatable.reduce((acc, item, idx) => acc + (parseInt(RQuantities[idx]) || 0), 0)}
                                                </td>
                                                {/* <td className="border-r text-right text-sm">{filteredDatatable.reduce((acc, item, idx) => acc + (RQuantities[idx] || 0), 0)}</td> */}
                                                <td className=" border-r text-right text-sm" style={{ backgroundColor: 'rgb(190 242 225)' }}>

                                                    {filteredDatatable.reduce((acc, item, idx) => {
                                                        const weight = Number(item.ItemBagWeight);
                                                        const qty = RQuantities[idx];
                                                        if (!isNaN(weight) && !isNaN(qty)) {
                                                            return acc + (weight * qty);
                                                        }
                                                        return acc;
                                                    }, 0)}
                                                </td>
                                                <td className="border-r text-right text-sm" style={{ backgroundColor: 'rgb(190 242 225)' }}>
                                                    {filteredDatatable.reduce((acc, item, idx) => acc + parseFloat(taxableAmount(item.RateAfterDiscount, item.GSTRate, RQuantities[idx], item.ItemBagWeight)), 0).toFixed(2)}
                                                </td>
                                                <td className="border-r text-right text-sm" style={{ backgroundColor: 'rgb(190 242 225)' }}>
                                                    {filteredDatatable.reduce((acc, item, idx) => acc + parseFloat(calculateGst(item.RateAfterDiscount, item.GSTRate, RQuantities[idx], item.ItemBagWeight)), 0).toFixed(2)}
                                                </td>
                                                <td className="px-4 py-2 border-r text-right text-sm" style={{ backgroundColor: 'rgb(190 242 225)' }}>
                                                    {filteredDatatable.reduce((acc, item, idx) => acc + parseFloat(calculateTotalAmount(item.RateAfterDiscount, item.GSTRate, RQuantities[idx], item.ItemBagWeight)), 0).toFixed(2)}
                                                </td>

                                                <td className="border-r text-right text-sm" style={{ backgroundColor: 'rgb(190 242 225)' }}></td>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </div>
                                <Dialog
                                    open={confirmDialogOpen}
                                    onClose={closeConfirmDialog}
                                    aria-labelledby="alert-dialog-title"
                                    aria-describedby="alert-dialog-description"
                                >
                                    <DialogTitle id="alert-dialog-title">{"Delete Record?"}</DialogTitle>
                                    <DialogContent>
                                        <DialogContentText id="alert-dialog-description">
                                            ⚠️ Are you sure you want to delete this Record?
                                        </DialogContentText>
                                    </DialogContent>
                                    <DialogActions>
                                        <button
                                            onClick={closeConfirmDialog}
                                            style={{
                                                backgroundColor: '#dc3545',
                                                color: '#ffffff',
                                                border: '1px solid #dc3545',
                                                borderRadius: '4px',
                                                padding: '8px 16px',
                                                cursor: 'pointer',
                                                marginRight: '8px',
                                            }}
                                        >
                                            Cancel
                                        </button>
                                        <button
                                            onClick={handleDelete}
                                            style={{
                                                backgroundColor: '#28a745',
                                                color: '#ffffff',
                                                border: '1px solid #28a745',
                                                borderRadius: '4px',
                                                padding: '8px 16px',
                                                cursor: 'pointer',
                                            }}
                                        >
                                            Confirm
                                        </button>
                                    </DialogActions>
                                </Dialog>
                            </TableContainer>
                        </div>
                    </CardContent>
                </div>

                {showModal && (
                    <Modal open={showModal} className={showModal ? 'notification-modal' : ''}>
                        <div className="fixed inset-0 flex items-start justify-center z-10 ">
                            <div className="bg-green-100  p-6 rounded-lg shadow-lg" style={{ width: '700px', maxHeight: '80vh', overflowY: 'auto', overflowX: 'auto' }}>
                                <div className="flex justify-end mt-2">
                                    <button className="close-button md:static md:mr-2" onClick={closeModal} style={{ marginTop: '-20px', color: 'black' }}>
                                        <Tooltip title="Close">
                                            <FaTimes />
                                        </Tooltip>
                                    </button>
                                </div>
                                <Card className="w-full sm:w-1/2 mb-4 rounded-lg shadow-lg" style={{ backgroundColor: 'rgba(255, 255, 255, 0)' }}>
                                    <CardContent>
                                        <div>
                                            {/* <h2 className="text-lg font-bold">{selectedCategory.label}</h2> */}
                                        </div>
                                        <div className='w-full mb-5' style={{ display: 'flex', flexWrap: 'wrap' }}>
                                            <input
                                                type="text"
                                                placeholder="Search by date (DD/MM/YYYY)"
                                                value={searchDate}
                                                onChange={(e) => {
                                                    setSearchDate(e.target.value);
                                                    handleSearch(e.target.value);
                                                }}
                                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline mb-2"
                                            />
                                            {filteredSaleData && filteredSaleData.map((item, index) => (

                                                <Card key={index} className="customCard" style={{
                                                    marginBottom: '10px',
                                                    backgroundColor: selectedInvoices.some(inv => inv.id === item.id) ? '#50C878' : (invoiceDates.includes(item.invoiceDate) ? 'red' : ''),

                                                    color: 'white', cursor: 'pointer'
                                                }}
                                                    onClick={() => handleInvoiceClick(item)}>
                                                    <CardContent style={{ height: '40px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                        <a href="#" className="tooltip-link" style={{ color: 'black' }}>
                                                            Date: {item.invoiceDate && new Date(item.invoiceDate).toLocaleDateString('en-GB')}
                                                        </a>

                                                    </CardContent>
                                                </Card>
                                            ))}

                                        </div>
                                    </CardContent>
                                </Card>
                            </div>
                        </div>
                    </Modal>
                )}


            </div>
        </div>
    );
};

export default SaleReturnEdit;
